<button kendoButton (click)="this.isOpen = true" [svgIcon]="icon" class="fbutton">Feedback</button>
<kendo-dialog *ngIf="this.isOpen" title="Feedback Formulier" width="800px" height="600px" maxHeight="90%" (close)="this.isOpen = false">
    <div class="wrapper">
        <div>Als u een probleem meldt, kan een screenshot erg handig zijn. Op Windows kunt u er een maken met: [Windows logo key + Shift + S]. Trek met de muisaanwijzer een kader om het gedeelte heen waar de screenshot van gemaakt moet worden. Vervolgens kunt u deze direct plakken met [Ctrl+V] in het feedback bericht.
          <br/><span style="color: sienna; font-weight: 800;">N.B. Als er na het plakken van de screenshot geen ruimte meer is om tekst toe te voegen, druk dan een paar keer op [Enter]</span>
        </div>
        <quill-editor [(ngModel)]="this.bericht" [style]="{height: '300px'}">
            <div quill-editor-toolbar>
                <span class="ql-formats">
                    <select class="ql-font">
                      <option selected></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                    <select class="ql-size">
                      <option value="small"></option>
                      <option selected></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-strike"></button>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select class="ql-align">
                      <option selected></option>
                      <option value="center"></option>
                      <option value="right"></option>
                      <option value="justify"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-link"></button>
                    <button class="ql-image"></button>
                  </span>
              </div>
        </quill-editor>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.isOpen = false">Cancel</button>
        <button kendoButton (click)="this.onFeedback()" themeColor="primary">
            Versturen
        </button>
    </kendo-dialog-actions>
</kendo-dialog>